export const dbPanels = {
  images: {
    subtitle: `Sube, ordena y define la imagen principal de cada unidad que aparecerá en tu motor de reservas.`,
  },

  amenities: {
    searchPlaceholder: `Buscar comodidad…`,
    selectedCount: `{count} comodidad seleccionada | {count} comodidades seleccionadas`,
    noResults: `Sin resultados para "{query}".`,
    // Fotos por comodidad: lo que el Agente IA le enseña al huésped.
    photos: {
      explain: `El agente se las enseñará al huésped que pregunte por esta comodidad.`,
      dropTitle: `Arrastra las fotos aquí`,
      addPhotos: `Añadir fotos`,
      dropHint: `JPG, PNG, WebP o HEIC · hasta {mb} MB cada una`,
      dropActive: `Suelta para subirlas`,
      uploading: `Subiendo… {progress}%`,
      uploaded: `{count} foto añadida | {count} fotos añadidas`,
      counter: `{count} foto | {count} fotos`,
      remaining: `Puedes añadir {count} foto más | Puedes añadir {count} fotos más`,
      full: `Ya tiene el máximo de {max} fotos`,
      tooMany: `Solo caben {max} fotos por comodidad.`,
      tooHeavy: `«{name}» pesa más de {mb} MB. Redúcela antes de subirla.`,
      notImage: `«{name}» no es una imagen.`,
      uploadError: `No se pudieron subir las fotos.`,
      removeAria: `Quitar esta foto`,
      deleteTitle: `¿Quitar esta foto?`,
      deleteBody: `El agente dejará de enseñarla cuando pregunten por «{amenity}». No se puede deshacer.`,
      deleteCancel: `Cancelar`,
      deleteConfirm: `Quitar foto`,
      deleted: `Foto quitada`,
      deleteError: `No se pudo quitar la foto.`,
      // Orden: el agente solo manda las primeras, por eso se puede arrastrar.
      orderHint: `El agente enseña las {count} primeras. Arrastra por el asa para cambiar el orden.`,
      dragTitle: `Arrastra para ordenar`,
      reordering: `Guardando el orden…`,
      orderSaved: `Orden guardado`,
      orderError: `No se pudo guardar el orden.`,
      willSend: `El agente enviará esta foto`,
      wontSend: `El agente no llega a enviar esta foto`,
      someFailed: `No se pudieron procesar: {names}`,
    },
  },

  occupancy: {
    question: `¿Qué ajuste quieres aplicar?`,
    questionRoom: `¿Qué ajuste quieres aplicar en esta habitación?`,
    modeNone: `Ninguno`,
    modeReduction: `Reducción`,
    modeSurcharge: `Aumento`,
    baseOccupancy: `Ocupación base`,
    baseHint: `huéspedes (el precio habitual)`,
    thOccupancy: `Ocupación`,
    thRule: `Regla`,
    thValue: `Valor`,
    thActive: `Activo`,
    guestsCount: `{count} huésped | {count} huéspedes`,
    ruleReductionPct: `Reducción %`,
    ruleReductionFixed: `Reducción {currency}`,
    reductionInfo: `Para menos huéspedes que la ocupación base, se aplica esta reducción sobre el precio del alojamiento.`,
    priceIncludes: `El precio incluye`,
    guestsCapacity: `huésped (capacidad de la habitación) | huéspedes (capacidad de la habitación)`,
    maxExtraGuests: `Máx. huéspedes extra`,
    chargePerExtraGuest: `Cargo por huésped extra`,
    chargeFixed: `{currency} fijo`,
    perNight: `por noche`,
    surchargeInfo: `Cada huésped por encima de la capacidad incluida paga este cargo por noche.`,
    noneRoom: `Esta habitación no tiene ajuste por ocupación: precio igual para cualquier número de huéspedes (dentro de la capacidad).`,
    noneBooking: `Esta reserva no tiene ajuste por ocupación: precio igual para cualquier número de huéspedes (dentro de la capacidad).`,
  },

  share: {
    title: `Compartir (Hotel)`,
    desc: `Este enlace es específico de este hotel. Compártelo por WhatsApp o ábrelo como visitante.`,
    linkLabel: `Link de reservas del hotel`,
    linkHint: `Úsalo en tu bio, campañas o mensajes automáticos.`,
    viewAsVisitor: `Ver como visitante`,
    tip: `Tip: Puedes enviar este link junto al mensaje de confirmación de reserva.`,
    noLinkCopy: `No hay link para copiar.`,
    copied: `Link copiado.`,
    copyError: `No se pudo copiar el link.`,
    noLinkShare: `No hay link para compartir.`,
    whatsappMsg: `Hola 👋 Te comparto el enlace para reservar en este hotel: {link}`,
    noLinkOpen: `No hay link para abrir.`,
  },

  unitServices: {
    title: `Equipamiento y comodidades`,
    subPrefix: `Comodidades de`,
    thisRoom: `esta habitación`,
    subInfo: `Cada tipo de habitación tiene las suyas; la reserva directa y el Agente IA usan las de la habitación asignada al huésped.`,
    loading: `Cargando comodidades…`,
    loadError: `No se pudieron cargar las comodidades de esta habitación.`,
    retry: `Reintentar`,
    saving: `Guardando…`,
    saved: `Guardado`,
    autosaveHint: `Se guarda automáticamente al marcar o desmarcar.`,
  },

  welcome: {
    tag: `Motor de reservas directas`,
    titleA: `Recibe reservas`,
    titleHighlight: `sin comisiones`,
    sub: `Tu propio motor de reservas por alojamiento: compartes un enlace, el huésped reserva y paga directo. Sin intermediarios ni comisiones de las OTAs.`,
    howItWorks: `Cómo funciona`,
    benefits: `Beneficios`,
    step1Title: `Comparte tu enlace`,
    step1Text: `Cada alojamiento tiene su enlace. Publícalo en tu web, redes o WhatsApp; el agente IA también lo envía a los leads.`,
    step2Title: `El huésped reserva`,
    step2Text: `Elige fechas y paga en tu motor. La reserva entra directa a tu calendario, sin comisiones de OTAs.`,
    step3Title: `Cobras directo`,
    step3Text: `Recibes el pago sin intermediarios y sumas promociones, cargos y servicios extra a cada estancia.`,
    ctaStart: `Empezar a configurar`,
    ctaPromotions: `Ver promociones globales`,
    perk1Title: `Cero comisiones de OTAs`,
    perk1Text: `Te quedas el 100% de cada reserva directa.`,
    perk2Title: `Pago y confirmación al instante`,
    perk2Text: `El huésped paga y la reserva se confirma sola.`,
    perk3Title: `Promociones y cargos extra`,
    perk3Text: `Descuentos por estancia, servicios y cargos propios.`,
    perk4Title: `Un enlace por alojamiento`,
    perk4Text: `Cada anuncio con su propio motor y disponibilidad.`,
  },

  unitsList: {
    title: `Unidades disponibles`,
    subtitle: `Activa las unidades que quieres mostrar en tu motor de reservas.`,
    loading: `Cargando…`,
    sectionUnits: `Unidades`,
    colUnit: `Unidad`,
    colCap: `Cap.`,
    colActive: `Activa`,
    noUnits: `No hay unidades configuradas.`,
    active: `Activa`,
    inactive: `Inactiva`,
    noticePrefix: `Activa las reservas directas desde`,
    noticeGlobalConfig: `Configuración global`,
    noticeSuffix: `para gestionar las unidades.`,
    sectionLink: `Link individual del apartamento`,
    linkCardTitle: `Enlace filtrado para este apartamento`,
    linkCardDesc: `Abre el mismo motor de reservas general, pero mostrando directamente este apartamento.`,
    viewAsVisitor: `Ver como visitante`,
    unitUpdated: `Unidad actualizada.`,
    updateError: `No se pudo actualizar.`,
    noLinkCopy: `No hay link para copiar.`,
    linkCopied: `Link copiado.`,
    copyError: `No se pudo copiar el link.`,
    noLinkOpen: `No hay link para abrir.`,
  },

  commonAreaImages: {
    intro: `Fotos generales (entrada, piscina, recepción, jardín…) que verá el cliente como portada al abrir el motor, además de la galería de cada unidad.`,
    imagesCount: `{count} imagen | {count} imágenes`,
    reorderHint: `Arrastra para ordenar · la principal es la portada`,
    reordering: `Ordenando…`,
    dragTitle: `Arrastrar`,
    coverBadge: `Portada`,
    empty: `Aún no has añadido fotos de zonas comunes. Súbelas arriba para crear la portada del anuncio.`,
    loadError: `No se pudieron cargar las fotos de zonas comunes.`,
    uploadSuccess: `Fotos subidas correctamente.`,
    uploadError: `No se pudieron subir las imágenes.`,
    orderUpdated: `Orden actualizado.`,
    orderError: `No se pudo actualizar el orden.`,
    deleteConfirmMsg: `¿Eliminar esta foto de zonas comunes?`,
    deleteConfirmHeader: `Eliminar imagen`,
    deleteAccept: `Eliminar`,
    deleteReject: `Cancelar`,
    imageDeleted: `Imagen eliminada.`,
    deleteError: `No se pudo eliminar la imagen.`,
    coverUpdated: `Portada actualizada.`,
    coverError: `No se pudo establecer la portada.`,
    invalidFiles: `Archivos no válidos: {message}\n{details}`,
  },
};
